export var BACKEND_API = {
    SHOPS: '/api/v1/shops',
    SETTINGS: '/api/v1/settings',
    GET_WEBHOOKS_BY_SHOP_ID: '/api/v1/webhooks/shop',
    CREATE_WEBHOOK: '/api/v1/webhooks',
    CREATE_FUNNEL: '/api/v1/funnels',
    CREATE_OR_UPDATE_WEBHOOK: '/api/v1/webhooks',
    DELETE_WEBHOOKS_BY_SHOP_ID: '/api/v1/webhooks/shop',
    SUBSCRIPTIONS: '/api/v1/subscriptions',
};
